import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import AddressPanel from 'components/AddressPanel/AddressPanel';
import DataSetsRecordButtons from 'components/DataSetsRecordButtons/DataSetsRecordButtons';
import Loader from 'components/Loader/Loader';
import Modal from 'components/Modal/Modal';
import Panel from 'components/Panel/Panel';
import Separator from 'components/Separator/Separator';
import TaxonomyDetailsPanel from 'components/TaxonomyDetailsPanel/TaxonomyDetailsPanel';

import FinancialPanel from './components/FinancialPanel/FinancialPanel';
import GeneralPanel from './components/GeneralPanel/GeneralPanel';

import type { ICreateProfitCentreView } from './interfaces/ICreateProfitCentreView';

import styles from './sass/CreateProfitCentreView.module.scss';

function CreateProfitCentreView({
  control, onProfitCentreSubmit, isConfirmationModalOpen, onHandleCloseConfirmation,
  onDiscardChangesConfirm, isPageLoading, onDateOpenedChange, dateOpened,
  onStartDateChange, startDate, onFindCountries, onFindStates, onFindCities,
  isStatesDisabled, onChangeCountry, onChangeState, isCitiesDisabled, enumData,
  naceCodesData, onNaceSelectionChange, naceDivisions, orgStructureData,
  defaultCountries, logicalName, setValue,
  vcOptionsList, handleGetVcOptions, listPosition,
}: ICreateProfitCentreView) {
  const { t } = useTranslation();
  const { recordId = '' } = useParams();
  const placeholder = recordId ? t('common.notProvided') : '';

  return (
    <div className={styles.root}>
      <Panel className={styles.panel}>
        <div className={styles.wrapper}>
          <Loader isPageLoading={isPageLoading} isFullLoader={false} />
          <GeneralPanel
            control={control}
            recordId={recordId}
            placeholder={placeholder}
            dateOpened={dateOpened}
            onDateOpenedChange={onDateOpenedChange}
            enumData={enumData}
            orgStructureData={orgStructureData}
            logicalName={logicalName}
            setValue={setValue}
            vcOptionsList={vcOptionsList}
            handleGetVcOptions={handleGetVcOptions}
            listPosition={listPosition}
          />
          <TaxonomyDetailsPanel
            control={control}
            naceCodesData={naceCodesData}
            naceDivisions={naceDivisions}
            onNaceSelectionChange={onNaceSelectionChange}
          />
          <FinancialPanel
            control={control}
            startDate={startDate}
            onStartDateChange={onStartDateChange}
          />
          <AddressPanel
            control={control}
            placeholder={placeholder}
            onFindCountries={onFindCountries}
            onFindStates={onFindStates}
            onFindCities={onFindCities}
            isStatesDisabled={isStatesDisabled}
            isCitiesDisabled={isCitiesDisabled}
            onChangeCountry={onChangeCountry}
            onChangeState={onChangeState}
            defaultCountries={defaultCountries}
            requiredState
          />
        </div>
        <Separator />
        <Modal
          open={isConfirmationModalOpen}
          title={t('createNewUser.cancelModalTitle')}
          description={t('clients.cancelModalText')}
          confirmTitle={t('common.discardChanges')}
          closeTitle={t('common.keepEditing')}
          confirmVariant="error"
          onClose={() => onHandleCloseConfirmation(false)}
          onReject={() => onHandleCloseConfirmation(false)}
          onConfirm={onDiscardChangesConfirm}
          isLoading={isPageLoading}
        />
        <DataSetsRecordButtons
          onClose={onHandleCloseConfirmation}
          onSubmit={onProfitCentreSubmit}
          isLoading={isPageLoading}
        />
      </Panel>
    </div>
  );
}

export default CreateProfitCentreView;
